export default __webpack_public_path__ + "static/media/banner_3b.5bdc449a.jpg";